import React, { createContext, useState } from 'react';
import Page, { PageContentBodyGrid } from "../Shared/Page/Page";
import WorkflowsList from './WorkflowsList';
import WorkflowDetails from './WorkflowDetails';
import { Switch, Route } from 'react-router';
import { PAGES, ROUTE_PATHS } from '../../InternalApiApp';

export const WorkflowContext = createContext();

const ActiveWorkflowsPage = () => {
	const [selectedWorkflow, setSelectedWorkflow] = useState(null);
	const [warnings, setWarnings] = useState(null)
	const [pausedFiles, setPausedFiles] = useState(null)

	return (
		<Page noBanner id="active-workflows-page" style={{ paddingLeft: "1rem", height: "calc(100vh - 128px)", overflowY: "hidden" }}>
			<PageContentBodyGrid style={{ height: "calc(100vh - 128px)", overflowY: "hidden" }} rowGap="m">
				<WorkflowContext.Provider value={{ warnings: warnings, setWarnings: (val) => setWarnings(val), pausedFiles: pausedFiles, setPausedFiles: (val) => setPausedFiles(val) }}>
					<Switch >
						<Route exact path={ROUTE_PATHS[PAGES.ACTIVE_WORKFLOWS] + "/:workflowId"} render={() => <WorkflowDetails selectedWorkflow={selectedWorkflow} setSelectedWorkflow={setSelectedWorkflow} />} />
						<Route exact path={ROUTE_PATHS[PAGES.ACTIVE_WORKFLOWS]} render={() => <WorkflowsList setSelectedWorkflow={setSelectedWorkflow} />} />
					</Switch>
				</WorkflowContext.Provider>
			</PageContentBodyGrid>
		</Page>
	);
}

export default ActiveWorkflowsPage;